export const USER_SIGNIN = '/api/auth/login'

export const PURCHASE_HISTORY = '/api/purchase-history'

export const CHANGE_PASSWORD_URL = '/api/password/change'

export const UPDATE_USER_DETAILS_URL = '/api/user'

export const COUNTRY_URL = '/api/country'

export const STATE_URL = '/api/state'

export const CITY_URL = '/api/city'

export const BATCH_URL = '/api/batch'

export const EXAM_LIST_URL = '/api/exam'
export const EXAM_TYPE_URL = '/api/exam-type'
export const EXAM_GRADE_URL = '/api/grade'

export const SUBJECT_URL = '/api/subject'
export const TOPICS_URl = '/api/topic'

export const REASONING_TYPE_URL = '/api/reasoning-type'
export const QUESTION_URL = '/api/question'
export const QUESTION_BULK_UPLOAD_URL = '/api/question/bulk-upload'

export const TOPIC_URL = '/api/topic'

export const STUDENT_LIST_URL = '/api/exam/'
export const QUESTION_WISE_STUDENT_LIST_URL = '/api/report/'

export const DASHBOARD_URL = '/api/report/candidate-performance'

export const COMPANY_DETAILS = '/api/dashboard'

export const EXAM_URL = '/api/exam/'

export const REPORT_QUESTION_URL_GET =
  '/api/question/flag-question/report-reasons'

export const REPORT_QUESTION_URL_POST = '/api/question/flag-question'

export const ADD_EMPLOYEES_TO_BATCH_URL = '/api/batch/<batch_id>/add-employees'

export const RETRIEVE_EXAM_REPORT = '/api/report/exam'
export const REGISTRATION_URL = '/api/register'
export const EXAM_REPORT_ANSWERS = '/api/report/submission-details'

export const BATCH_BULK_UPLOAD_EMPLOYEES_URL =
  '/api/batch/<batch_id>/bulk-upload-employees'
export const BATCH_BULK_UPLOAD_EXTERNAL_CANDIDATES_URL =
  '/api/batch/<batch_id>/bulk-upload-candidates'
export const BATCH_MEMBERS_LIST_URL = '/api/batch/<batch_id>/list-members'
export const BATCH_RESULT_URL = '/api/batch/batch-exam-list'

export const SEND_INVITE_TO_JOIN_BATCH_URL =
  '/api/batch/<batch_id>/invite-by-email'

export const FORGOT_PASSWORD_URL = '/api/password/reset'

export const RESET_PASSWORD_URL = '/api/password/verify'
export const NOTIFICATION_URL = '/api/notification'
export const FETCH_RANDOM_USERNAME_PWD_URL = '/api/fetch-random-username-pwd'
export const FETCH_BULK_UPLOAD_DETAILS_URL = '/api/fetch-bulk-upload'

export const CREATE_AUTOGENERATE_EXAM_QUESTION =
  '/api/exam/auto-generate-questions'
// Employee management endpoint
// export const GET_EMPLOYEE_URL = '/api/user'
export const GET_EMPLOYEE_URL = '/api/institute/employee-list'
export const ADD_EMPLOYEE_URL = (id) => `/api/institute/${id}/add-user`
export const EDIT_USER_URL = (id) => `/api/user/${id}`
export const GET_BRANCH_URL = '/api/institute'
export const GET_DEPARTMENT_URL = '/api/department'
export const ADD_BULK_EMPLOYEE_URL = 'api/institute/upload-employees-to-branch'

export const ADD_BULK_EMPLOYEE_HISTORY_URL =
  'api/institute/uploaded-branch-employees-history'

export const SEND_BATCH_EMAIL_INVITE_URL = '/api/batch/send-batch-invite'

//organisation profile
export const GET_ORGANIZATION_PROFILE_URL = (id) => `/api/institute/${id}`
export const BRANCH_LIST_URL = '/api/institute'

export const QUESTIONNAIRE_UPLOAD_URL = '/api/question-paper/upload'
export const QUESTIONNAIRE_UPLOAD_HISTORY_URL =
  '/api/question-paper/uploaded-history'
export const QUESTIONNAIRE_LIST_URL = '/api/question-paper'
export const INSTITUTE_URL = '/api/institute'
export const ADD_EMPLOYEES_TO_BRANCH_URL =
  '/api/institute/<institute_id>/add-employees-to-branch'
export const BRANCH_MEMBERS_LIST_URL = '/api/institute/<institute_id>/members'
export const REMOVE_MEMBER_FROM_BRANCH_URL =
  '/api/institute/<institute_id>/remove-member-from-branch'
export const BULK_UPLOAD_BRANCH_MEMBERS_URL =
  'api/institute/upload-employees-to-branch'

// SME dashboard
export const GET_EXAM_CREATE_REQUEST_LIST_URL = '/api/exam-creation-request'

export const GET_EXAM_CREATE_COUNT_URL =
  '/api/report/exam-creation-request-count'

export const GET_EXAM_PERFORMANCE_URL = '/api/report/sme-exam-performance'
export const QUESTIONNAIRE_DETAILS_URL = '/api/question-paper'

export const EXAM_CREATION_DETAILS_URL = '/api/exam-creation-request'

// Corporate dashboard

export const CORPORATE_ADMIN_DASHBOARD_TOTAL_DETAILS_URL = (id) =>
  `api/institute/${id}/institute-dashboard`

export const CORPORATE_ADMIN_BRANCH_PERFORMANCE_URL =
  '/api/report/branch-performance-overview'

export const CORPORATE_ADMIN_BRANCH_EXPENDITURE_URL =
  'api/report/question-paper-expenditure'

export const DELETE_UPLOAD_HISTORY_URL = '/api/fetch-bulk-upload'

export const JOB_ROLE_URL = '/api/job-description'
export const GET_USER_MOVEMENT_IMAGES_URL = '/api/report/exam'

export const GET_QUALIFICATION_URL = '/api/qualification'

export const PROCESS_RESUME_URL = '/api/resume-reader/'
export const GET_RESUME_LINK_URL = '/get-resume-link'
export const UPLOAD_RESUME_URL = '/api/batch/BATCH_ID/upload-batch-resume'

export const ASSIGN_VIEW_REPORT_PERMISSION_URL =
  '/api/report/examId/candidate-access-report'

export const GET_QUESTION_PAPER = '/api/exam-v2/examId/question-paper'
export const GET_EXAM_QUESTIONS_URL = '/api/exam-v2/examId/question'
export const GET_EXAM_BATCHES_URL = '/api/exam/examId/batches'

export const GET_BATCH_INVITATIONS_URL = '/api/batch/invitation'
export const ACCEPT_BATCH_INVITATIONS_URL = '/api/batch/REQUEST_ID/invitation'

export const EXAM_TYPE_WISE_SUBJECT_LIST_URL = '/api/subject/by-tags'
export const SUBJECT_WISE_TOPICS_URL = '/api/topic/by-subject'

// Resume library
export const RESUME_LIBRARY_LIST_URL = '/api/resume'
export const RESUME_LIBRARY_DETAIL_URL = (resumeId) => `/api/resume/${resumeId}`
export const RESUME_LIBRARY_ASSIGN_HISTORY_URL = (resumeId) =>
  `/api/resume/${resumeId}/assignment-history`
export const RESUME_ACTIVITY_URL = (resumeId) =>
  `/api/resume/${resumeId}/activity`
export const ASSIGN_TO_BATCH_LIST_URL = '/api/batch/dropdown'
export const ASSIGN_TO_BATCH_SKILL_MATCH_URL = (batchId) =>
  `/api/resume/${batchId}/skills-match`
export const RESUME_BULK_DELETE_URL = '/api/resume/bulk-delete'
export const RESUME_BULK_BOOKMARK_URL = '/api/resume/bookmark-resume'
export const JD_LIST_URL = 'api/job-description/dropdown'
export const JD_DETAILS_URL = (jdId) => `/api/job-description/${jdId}`
export const RESUME_ASSIGN_TO_BATCH_URL = (batchId) =>
  `api/resume/${batchId}/upload`
export const RESUME_BULK_DOWNLOAD_URL = '/get-resume-links'
// Get skills from JD
export const GET_SKILL_SET_URL = '/api/skill'
export const CREATE_SKILL_SET_URL = '/api/skill'
export const PROCESS_JS_SKILL_SET_URL = '/process-jd-data'
export const GET_SKILL_SET_LIST_URL = '/api/skill/skill-list'

// Recruitment Agencies
export const RECRUITMENT_AGENCIES_LIST_URL = '/api/institute/agency-list'
export const GET_AGENCIES_DETAIL_URL = (id) => `/api/recruitment/agency/${id}`
export const GET_RECRUITMENT_AGENCIES_REQUEST_LIST_URL = `/api/connection/company-agency`
export const GET_RECRUITMENT_AGENCIES_REQUEST_DETAIL_URL = (id) =>
  `/api/connection/company-agency/${id}`
export const SEND_RECRUITMENT_AGENCIES_CONNECTION_REQUEST_URL = `/api/connection/company-agency`
export const ACCEPT_EMAIL_INVITATION_URL = (req_id) =>
  `/api/recruitment/job_descriptions/${req_id}/email-invitation`
export const GET_RECRUITMENT_JD_INVITATION_URL =
  '/api/recruitment/job_descriptions/invitation-list'
export const GET_RECRUITMENT_JD_LIST_URL =
  '/api/recruitment/job_descriptions/agency-jd-list'
export const GET_RECRUITMENT_SHARED_CANDIDATE_LIST_URL =
  '/api/recruitment/job_descriptions/shared-candidates'
export const GET_AVERAGE_TIME_TO_FILL_DATA_URL = (institute_id) =>
  `/api/institute/${institute_id}/jd-average-time`
export const GET_CANDIDATE_QUALITY_DISTRIBUTION_DATA_URL = (institute_id) =>
  `/api/institute/${institute_id}/candidate-quality-distribution`
export const GET_SUBMISSION_TRACK_DATA_URL = (institute_id) =>
  `/api/institute/${institute_id}/submission-track`
export const GET_OVERALL_SUBMISSION_STATS_DATA_URL = (institute_id) =>
  `/api/institute/${institute_id}/overall-submission-stats`

// Job Role
export const GET_JOB_ROLE_SUBMITTED_CANDIDATE_LIST_URL = (id) =>
  `/api/job-description/${id}/submitted-candidate`
export const UPDATE_JD_DEACTIVATION_SETTING_URL = (id) =>
  `/api/jd-setting/${id}`
